type Props = {
  pageIndex: number
  length: number
}

const Page = ({ pageIndex, length }: Props) => (
  <div className="mx-2">
    Page {pageIndex + (length > 0 ? 1 : 0)} of {length}
  </div>
)

export default Page
